<template>
  <table
    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  >
    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
      <tr>
        <slot name="head" />
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, index) in data"
        :key="index"
        class="bg-white border-b hover:bg-gray-50"
      >
        <!-- icone, tipo e descrição -->
        <th
          scope="row"
          class="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap"
        >
          <component :is="PhGear" class="h-7 w-7" />

          <!-- nome e função -->
          <div class="ps-3">
            <div class="text-base font-semibold">
              {{ row.type }}
            </div>

            <div class="font-normal text-gray-500">
              {{
                row?.description
              }}
            </div>
          </div>
        </th>

        <!-- motivo -->
        <td class="px-1 py-4">
          <div class="flex items-center">
            <div
              class="h-2.5 w-2.5 rounded-full me-2"
            ></div>
            {{ row?.motivo ?? 'não informado' }}
          </div>
        </td>

        <!-- realizado em -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div>
            <div class="text-base font-semibold">
              {{
                row["carried_out_in"]
              }}
            </div>
          </div>
        </td>

        <!-- ações -->
        <td class="px-6 py-4">
          <div class="flex justify-center font-medium">
            <!-- Remover manutenção -->
            <a
              title="Remover registro"
              class="text-red-600 mr-1 hover:underline cursor-pointer"
              @click="deleteDoc(row['id'])"
            >
              <component :is="PhTrash" class="h-6 w-6" />
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup> import {
  PhGear,
  PhTrash
} from '@phosphor-icons/vue'
import { defineProps } from 'vue'

const props = defineProps({
  data: [Object, Array]
})

const emit = defineEmits(['delete'])

function deleteDoc (id) {
  emit('delete', id)
}

</script>
